import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm text-foreground-600">
      <Link to="/" className="transition-colors hover:text-accent-600 cursor-pointer">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-accent-600 cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-950">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}